// Module
var code = "<div class=\"chart-wrapper\">\n    <p style=\"text-align: center;\">{{ name }}</p>\n</div>";
// Exports
module.exports = code;